<div class="container-fluid">
  <atlas-sidenav-container class="dls-container">

    <!-- Left Side Drawer -->
    <atlas-sidenav class="p-0 container-side-nav" #sidenavStart [opened]="screenWidth > 1023"
      [mode]="(screenWidth > 1023) ? 'side' : 'over'">

      <!-- Left Side Navigation -->
      <dls-side-navigation-menu></dls-side-navigation-menu>

    </atlas-sidenav>

    <!-- Application content -->
    <atlas-sidenav-content #sideNavContent>

      <!-- Header -->
      <dls-header [sideNav]="sidenavStart"></dls-header>

      <div class="row no-gutters p-3 p-md-4 p-lg-5 main-content">
        <!-- Primary Router Outlet -->
        <div class="col">
          <router-outlet></router-outlet>
        </div>

        <!-- Right side navigation -->
        <dls-page-navigation *ngIf="screenWidth > 1440" [ngClass]="{'d-none': !showPageNavigation }"
          class="col ms-3 ms-md-4 ms-lg-5 dls-page-scroll"></dls-page-navigation>

        <!-- FAB for back to top -->
        <button 
          atlas-fab 
          color="accent"
          atlasTooltip="Back to top"
          class="fab-back-to-top d-none d-md-block me-3 me-md-4 me-lg-5"
          [@fab]="fabState" 
          (click)="backToTop()" 
          aria-label="Back to top button">
          <mat-icon>
            arrow_upward
          </mat-icon>
        </button>
        <!-- Mini FAB -->
        <button 
          atlas-mini-fab
          color="accent"
          atlasTooltip="Back to top"
          [@fab]="fabState" 
          (click)="backToTop()" 
          class="mini-fab-back-to-top d-block d-md-none me-3 me-md-4 me-lg-5"
          aria-label="Back to top button">
          <mat-icon>
            arrow_upward
          </mat-icon>
        </button>
      </div>

      <!-- Footer -->
      <dls-footer></dls-footer>
    </atlas-sidenav-content>
  </atlas-sidenav-container>
</div>
